<template>
  <span>
    <div v-if="showInfo">
      <base-alert type="secondary">
          <span class="alert-inner--icon"><i class="ni ni-air-baloon"></i></span>
          <span class="alert-inner--text">{{ $t('info') }}</span>
      </base-alert>
    </div>
  </span>
</template>

<script>
export default {
  computed: {
    showInfo() {
      const cases = this.$store.getters.getIsClassic ? this.$store.getters.getNumberOfCases : this.$store.getters.getNumberOfRPSCases;
      return (cases === this.$store.state.main.game.currentCaseNumber &&
        this.$store.getters.getIsFacilitator &&
        !this.$store.state.main.playerIsObserver &&
        this.$store.getters.countPausedPlayers)
    }
  }
}

</script>
<i18n>
{
  "en": {
    "info": "When you close the game, also the paused players are taken to the finishing page and can no longer answer the cases."
  },
  "fi": {
    "info": "Sulkiessasi pelin myös tauolla olevat pelaajat siirtyvät lopetussivulle eivätkä voi enää vastata tilanteisiin."
  },
  "sv": {
    "info": "När du stänger spelet kommer även de pausade spelarna till sista sidan och kan inte längre svara på frågorna."
  },
 "de": {
   "info": "Wenn Sie das Spiel beenden, gehen auch die Spieler in der Pause auf die Endseite und können nicht mehr auf Situationen reagieren."
 },
  "ko": {
    "info": "시뮬레이션을 종료하면 일시정지된 플레이어는 시뮬레이션 마지막 화면으로 이동되며 더 이상 응답할 수 없습니다."
  }
}
</i18n>
